// Redux
import { createAction } from '@reduxjs/toolkit';

const closeAction = createAction('orderRejectionBySaturatedStoreDialog/close');

const clearAction = createAction('orderRejectionBySaturatedStoreDialog/clear');

const openAction = createAction<{ orderId: number; refuseReason: any }>(
  'orderRejectionBySaturatedStoreDialog/open',
);

const clear = () => (dispatch: any) => {
  dispatch(clearAction());
};

const close = () => (dispatch: any) => {
  dispatch(closeAction());
};

const open = (orderId: number, refuseReason: any) => (dispatch: any) => {
  dispatch(openAction({ orderId, refuseReason }));
};

const actions = {
  clear,
  clearAction,
  close,
  closeAction,
  open,
  openAction,
};

export default actions;
